import styled from 'styled-components'
import { WHITE } from "@styles/colors"
import { safeAreaInset } from "@lib/telegram"

export const ScrollContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  padding-bottom: 100px;
`

export const RedemptionDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 12px;
  justify-content: space-between;
  gap: 12px;
`

export const BankInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  justify-content: space-between;
  gap: 8px;
`

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  background-color: ${WHITE};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`
